var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 27,
    viewBox: "0 0 34 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.636719 24.2941L3.64756 25.4356C5.67676 19.8628 7.90228 14.7596 10.6516 10.731C13.2698 6.90381 15.6916 4.95678 17.197 4.3526C18.7025 3.74842 18.964 4.55399 18.7025 6.03136C18.4409 7.6425 17.5245 9.85856 16.7385 11.8732C15.6909 14.4244 14.5129 17.3116 14.5129 19.5276C14.5129 21.6092 15.8872 23.2203 17.6549 23.2203C19.6189 23.2203 21.3206 20.8705 22.6949 18.9903C25.3783 15.1631 27.5386 13.3506 26.2296 18.3185C25.6406 20.8697 25.1168 23.0189 26.6222 25.0997C27.9965 27.0468 30.811 27.584 33.364 25.4356L31.6622 22.8844C29.6982 24.2941 28.6514 23.69 28.8477 21.6084C28.9789 20.2656 29.8953 17.9826 29.8953 15.9687C29.8953 13.6189 28.3247 12.007 26.3607 12.0746C24.07 12.1415 22.106 14.8272 20.5353 16.8419C19.8152 17.782 18.0483 20.5346 17.7208 19.9304C17.197 18.9903 18.9647 14.9617 19.75 13.1492C20.8628 10.2621 22.0408 7.37497 22.0408 5.09203C22.0408 2.4063 20.2079 0.727539 17.9824 0.727539C12.746 0.726796 5.2841 11 0.636719 24.2941Z",
    fill: "#021D1D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.364559b1d75f0b02a8ef2864e23dd1d5.svg";
export { ForwardRef as ReactComponent };